// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__iewaM","alert":"SettungsInbox_alert__1P_h5"};